// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notfound-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f8f9fa;
  padding: 20px;
  text-align: center;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.notfound-content {
  max-width: 600px;
}

.notfound-code {
  font-size: 8rem;
  color: #dc3545;
  margin: 0;
}

.notfound-message {
  font-size: 2rem;
  margin-top: 0.5rem;
  color: #343a40;
}

.notfound-description {
  font-size: 1rem;
  color: #6c757d;
  margin: 1rem 0 2rem 0;
}

.notfound-home-button {
  padding: 0.75rem 1.5rem;
  background-color: #007bff;
  color: #ffffff;
  text-decoration: none;
  border-radius: 5px;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.notfound-home-button:hover {
  background-color: #0056b3;
}
`, "",{"version":3,"sources":["webpack://./src/styles/notfound.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,4DAA4D;AAC9D;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".notfound-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background-color: #f8f9fa;\n  padding: 20px;\n  text-align: center;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.notfound-content {\n  max-width: 600px;\n}\n\n.notfound-code {\n  font-size: 8rem;\n  color: #dc3545;\n  margin: 0;\n}\n\n.notfound-message {\n  font-size: 2rem;\n  margin-top: 0.5rem;\n  color: #343a40;\n}\n\n.notfound-description {\n  font-size: 1rem;\n  color: #6c757d;\n  margin: 1rem 0 2rem 0;\n}\n\n.notfound-home-button {\n  padding: 0.75rem 1.5rem;\n  background-color: #007bff;\n  color: #ffffff;\n  text-decoration: none;\n  border-radius: 5px;\n  font-weight: bold;\n  transition: background-color 0.3s ease;\n}\n\n.notfound-home-button:hover {\n  background-color: #0056b3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
